module.exports = __webpack_public_path__ + "img/company_list_background.75275dc5.png";